<template lang="pug">
PageLayout(:page="page" v-if="page")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { useAsyncData, useRoute, useRuntimeConfig, type NuxtApp } from "#app"
import { getPage } from "~/services/public/Pages"
import { TestLabService } from "~/services/public/TestLab"

export default defineComponent({
  name: "SlugLevel4Page",

  middleware: ["preview"],

  setup(props, { expose }) {
    const route = useRoute()
    const configPublic = useRuntimeConfig().public

    const { data: page, error } = useAsyncData(async () => {
      try {
        const response = await getPage(configPublic, route.fullPath)

        if (response.loading === false && response.data) {
          if (response.data.contentNode) {
            return response.data.contentNode
          } else {
            throw new Error("Page not found - data error")
          }
        }
      } catch (err) {
        throw new Error("Page not found - response error")
      }
    })

    expose({ page })

    return {
      page
    }
  },

  mounted(): void {
    if (this.page) {
      this.initializeTestLab()
    }
  },

  methods: {
    async initializeTestLab(): Promise<void> {
      if (!this.page?.blocks) return

      const testLabService = new TestLabService(
        this.$axios,
        this.$config.public,
        this.$snowplow,
        this.$store
      )
      // adds experiment context to vuex store if page has any experiments.
      await testLabService.handleExperiments(this.page.blocks)
      this.$snowplow.trackViewForPage(this.page)
    }
  }
})
</script>
